import { render, staticRenderFns } from "./ConsultationsAndReworks.vue?vue&type=template&id=5c8ba696"
import script from "./ConsultationsAndReworks.vue?vue&type=script&lang=js"
export * from "./ConsultationsAndReworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports